import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatNumber, formatMoney, formatPercent } from '../utils'

export const networkDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'sum',
      field: 'impressions',
      headerName: 'Impressions',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'clicks',
      headerName: 'Clicks',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'cpmAvg',
      field: 'cpm',
      headerName: 'CPM',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'cvrAvg',
      field: 'cvr',
      headerName: 'CVR',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'ctrAvg',
      field: 'ctr',
      headerName: 'CTR',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'greyFill',
  headerName: 'Network',
}
